import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'card', 'emptyState'];
  static values = {
    activeFilter: { type: String, default: 'all' },
  };

  connect() {
    this.activeFilter = this.activeFilterValue;
    this.applyFilter();
  }

  switchTab(event) {
    this.activeFilter = event.currentTarget.dataset.filter;
    this.applyFilter();
    this._persistFilterInUrl(this.activeFilter);
  }

  cardTargetConnected() {
    this.applyFilter();
  }

  applyFilter() {
    let visibleCount = 0;
    this.cardTargets.forEach((card) => {
      const matches = this.activeFilter === 'all' || card.dataset.propertyId === this.activeFilter;
      card.classList.toggle('hidden', !matches);
      if (matches) visibleCount += 1;
    });

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.filter === this.activeFilter;
      tab.classList.toggle('bg-white', active);
      tab.classList.toggle('shadow-sm', active);
      tab.classList.toggle('text-brand-1000', active);
      tab.classList.toggle('text-black-500', !active);
      tab.classList.toggle('hover:bg-white/50', !active);
    });

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle('hidden', visibleCount > 0);
    }
  }

  _persistFilterInUrl(filter) {
    const url = new URL(window.location.href);

    if (filter === 'all') {
      url.searchParams.delete('property_id');
    } else {
      url.searchParams.set('property_id', filter);
    }

    window.history.replaceState(window.history.state, '', url.toString());
  }
}
